import React, { Fragment, useEffect, useState } from 'react';
import { Modal, Card, Container, Row, Col, Button } from 'react-bootstrap';
import { configuracionFormAction39, obtenerPretensionesImplicados} from '../../store/actions/administracion-caso-action';
import { useSelector, useDispatch } from 'react-redux';
import { Auth, LoadingComponent } from 'recupero-comunes';
import GrillaPretensionesImplicado from './grillaPretensionesImplicados';

const VerPretensionesModal = ({ action, showPretensiones, handleClosePretensiones }) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false)

    const data_encargado = useSelector((state) => state.encargadoCompaniaReducer);
    const { llaves } = data_encargado;

    const data_administra_defensa = useSelector((state) => state.administracionCasoReducer)
    const { cfg_form39, listaPretensionesImplicados } = data_administra_defensa

    useEffect(() => {
        if (showPretensiones && llaves) {
            setLoading(true);
            let query = Buffer.from(JSON.stringify({ rutcia: llaves && llaves['idOrgCaso'], idform: 39 })).toString('base64')
            dispatch(configuracionFormAction39(query))
            .then(() => {
                let query = Buffer.from(JSON.stringify({ idCaso: llaves['idCaso'], tipoMovimiento: 261001 })).toString('base64')
                dispatch(obtenerPretensionesImplicados(query)).then(() => setLoading(false))
            })
        }
    }, [showPretensiones, llaves])

    return (
        <Fragment>
            <LoadingComponent show={loading} />
            <Modal show={showPretensiones} onHide={handleClosePretensiones} size='xl'>
                <Card>
                    <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#4F517A', color: 'white' }}>
                        {cfg_form39 ? cfg_form39.cfg_form39['modapretenciones-title-modal'] : ''} Caso {llaves && llaves['idCaso']}
                    </Card.Header>
                    <Card.Body>
                        <GrillaPretensionesImplicado />
                        <hr style={{ borderTop: '2px solid #04005D' }}></hr>
                        <Container>
                            <Row>
                                <Col className='d-flex align-items-end justify-content-end m-2 p-0'>
                                    <Button className='m-2 w-auto' variant='outline-info' onClick={handleClosePretensiones}>
                                        {cfg_form39 ? cfg_form39.cfg_form39['modapretenciones-btn-volver'] : ''}
                                    </Button>
                                </Col>
                            </Row>
                        </Container>
                    </Card.Body>
                </Card>                
            </Modal>
        </Fragment>
    )
}

export default VerPretensionesModal;
